function Courses() {
  const courses = [
    // Senior Courses
    {
      tag: "Bestseller",
      name: "SPLASH",
      image: "splash",
      eligibility: "10th Pass",
      duration: "2 Years",
      description:
        "Complete Syllabus of 11th & 12th with focus on IIT-JEE & NEET",
    },
    {
      name: "SAGA",
      image: "saga",
      eligibility: "11th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 12th with focus on IIT-JEE & NEET",
    },
    {
      name: "SALEINT",
      image: "saleint",
      eligibility: "12th Pass",
      duration: "1 Year",
      description:
        "Complete Syllabus of 11th & 12th with focus on IIT-JEE & NEET",
    },

    // Class 7th
    {
      category: "Class 7",
      name: "Sprout (A)",
      image: "sprout",
      eligibility: "6th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 7th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 7",
      name: "Sprout (A+)",
      image: "sprout",
      eligibility: "6th Pass",
      duration: "4 Years",
      description:
        "Complete Syllabus of 7th to 10th with focus on NTSE / OLYMPIAD / KVPY",
    },
    {
      category: "Class 7",
      name: "Sprout (A++)",
      image: "sprout",
      eligibility: "6th Pass",
      duration: "6 Years",
      description:
        "Complete Syllabus of 7th to 12th with focus on IIT-JEE & NEET",
    },

    // Class 8th
    {
      category: "Class 8",
      name: "Sprout (A)",
      image: "sprout",
      eligibility: "7th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 8th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 8",
      name: "Sprout (A+)",
      image: "sprout",
      eligibility: "7th Pass",
      duration: "3 Years",
      description:
        "Complete Syllabus of 8th to 10th with focus on NTSE / OLYMPIAD / KVPY",
    },
    {
      category: "Class 8",
      name: "Sprout (A++)",
      image: "sprout",
      eligibility: "7th Pass",
      duration: "5 Years",
      description:
        "Complete Syllabus of 8th to 12th with focus on IIT-JEE & NEET",
    },

    // Class 9th
    {
      category: "Class 9",
      name: "Sprout (B)",
      image: "sprout",
      eligibility: "8th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 9th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 9",
      name: "Sprout (B+)",
      image: "sprout",
      eligibility: "8th Pass",
      duration: "2 Years",
      description:
        "Complete Syllabus of 9th to 10th with focus on NTSE / OLYMPIAD / KVPY",
    },
    {
      category: "Class 9",
      name: "Sprout (B++)",
      image: "sprout",
      eligibility: "8th Pass",
      duration: "4 Years",
      description:
        "Complete Syllabus of 9th to 12th with focus on IIT-JEE & NEET",
    },

    // Class 10th
    {
      category: "Class 10",
      name: "Sprout (C)",
      image: "sprout",
      eligibility: "9th Pass",
      duration: "1 Year",
      description: "Complete Syllabus of 10th with focus on NTSE / OLYMPIAD",
    },
    {
      category: "Class 10",
      name: "Sprout (C+)",
      image: "sprout",
      eligibility: "9th Pass",
      duration: "3 Years",
      description:
        "Complete Syllabus of 10th to 12th with focus on IIT-JEE & NEET",
    },
  ];

  return (
    <>
      <section class="py-8 d-flex align-items-center bg-auto bg-image-2">
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-12">
              <div className="z-2 position-relative">
                <h1 class="mb-2 display-5 ls-sm text-white fw-bold">
                  <span>Albedo Institute, Ranchi</span>
                </h1>
                <ol class="breadcrumb">
                  <li class="breadcrumb-item fs-5">
                    <a href="#">Home</a>
                  </li>
                  <li
                    class="breadcrumb-item active fs-5 text-white"
                    aria-current="page"
                  >
                    Our Courses
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-2">
        <div className="container mb-7">
          <div className="row">
            <div className="col-12 d-flex justify-content-between align-items-center">
              <div className="row mt-5">
                <div className="col-md-10 col-12">
                  <span class="text-dark ls-md text-uppercase fw-semibold">
                    Programs Designed for Success
                  </span>
                  <h2 className="mb-1 display-6 fw-bold text-dark lh-1">
                    Structured courses tailored to{" "}
                    <u class="text-primary">
                      <span class="text-primary">different academic goals</span>
                    </u>
                  </h2>
                  <p className="fs-4 text-secondary fw-normal lh-sm mt-2 mb-0">
                    Each program is designed with a balanced focus on conceptual
                    understanding, practice, and assessment, ensuring students
                    progress with clarity and confidence at every stage of their
                    academic journey.
                  </p>
                  <div className="mb-2">
                    <a
                      class="btn btn-outline-dark px-5 btn-md mt-3 py-1 rounded-pill me-1"
                      href="/introduction"
                    >
                      About Albedo Institute
                    </a>
                    <a
                      class="btn btn-dark px-5 btn-md mt-3 py-1 rounded-pill"
                      href="/introduction"
                    >
                      Our Courses
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="row g-2 mt-2">
              {courses.map((course, index) => (
                <div className="col-lg-4 col-12" key={index}>
                  <div className="row g-0 rounded-5 h-100">
                    <div className="col-12 px-4 d-flex align-items-center bg-light pb-3 pt-2 rounded-4">
                      <div>
                        <img
                          src={`/assets/images/${course.image}.jpg`}
                          height="80"
                          className="rounded-3"
                        />
                      </div>
                      <div className="d-flex flex-column ps-4 pe-2 mb-2">
                        <div className="d-flex flex-column mt-3">
                          <h3 className="mb-0 lh-1">
                            <a href="#" className="fs-4 text-dark">
                              {course.name} Course
                            </a>
                          </h3>

                          <p className="mb-0 lh-sm mt-1 mb-0">
                            {course.description}. <br />
                            <br />
                            Course Duration — {course.duration}.
                          </p>

                          <span className="text-gray-500">
                            Eligibility — <a href="#">{course.eligibility}</a>
                          </span>
                        </div>

                        <div className="mt-3">
                          <a
                            className="btn bg-gold text-dark px-5 py-1 rounded-pill border-0"
                            href="/"
                          >
                            Enroll Now
                          </a>

                          <a
                            className="btn btn-icon btn-success btn-sm rounded-circle d-none d-md-inline-flex ms-1"
                            href="/"
                          >
                            <i className="bi bi-whatsapp fs-4 align-middle" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div className="px-8">
                      <div className="bg-danger pt-1 mt-n1"></div>
                    </div>
                  </div>
                </div>
              ))}

              <div className="col-lg-4 col-12">
                <div className="row g-0 rounded-5 h-100">
                  <div className="col-12 px-4 bg-dark pb-3 pt-2 rounded-4 d-flex justify-content-center align-items-center">
                    <div className="text-center text-white mt-lg-0 mt-4">
                      <span className="badge bg-white-soft mb-2 rounded-pill fs-5 px-4">
                        Enroll Now
                      </span>
                      <h4 className="text-white fs-3 m-0 lh-1">
                        Enroll for Courses at Albedo
                      </h4>
                      <p className="mb-1">
                        Begin Your Journey Toward Academic Excellence
                      </p>

                      <a
                        class="btn btn-white px-5 btn-md mt-3 py-1 rounded-pill mb-lg-0 mb-5 me-1"
                        href="/introduction"
                      >
                        Albedo Registration Form
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Courses;
